import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReportsBreadCrumbs from 'src/pages/Reports/ReportsBreadCrumbs';
import ReportsList from './ReportsList';
import ReportLicense from '../../components/report-license/report-license';
import ReportPrescription from '../../components/report-prescription/report-prescription';
import NoAccess from '../../components/no-access/no-access';
import { selectCurrentUser } from 'src/modules/users/selector';
import { useAppSelector } from 'src/hooks/redux';

function ReportsMainGos() {
  const { reportID } = useParams();

  const path =
    reportID === '1'
      ? ['Отчет по лицензиям']
      : reportID === '2'
      ? ['Отчет по предписаниям']
      : [];

  const [crumbs, setCrumbs] = useState<string[]>(path);

  const user = useAppSelector((state) => selectCurrentUser(state));

  const handleSetCrumbs = (newCrumb: string) => {
    setCrumbs(() => [newCrumb]);
  };

  useEffect(() => {
    if (!reportID) {
      setCrumbs([]);
    }
  }, [reportID]);

  return (
    <>
      {(user.infoGOS.editor || user.infoGOS.admin) && (
        <>
          {reportID ? (
            <>
              {reportID === '1' && <ReportLicense />}
              {reportID === '2' && <ReportPrescription />}
            </>
          ) : (
            <>
              <ReportsBreadCrumbs reportsCrumbs={crumbs} />
              <ReportsList onSetCrumbs={handleSetCrumbs} />
            </>
          )}
        </>
      ) || (
        <NoAccess />
      )}
    </>
  );
}


export default ReportsMainGos;
